export const en = {
    nav: {
        overview: 'Overview',
        cases: 'Cases',
        ai_visibility: 'AI Visibility',
        dark_web: 'Dark Web',
        address: 'Address Monitoring',
        guides: 'Guides',
        details: 'My Details',
        settings: 'Settings',
        plans: 'Plans',
        support: 'Support',
        home: 'Home',
        how_it_works: 'How it works',
        pricing: 'Pricing',
        faq: 'FAQ',
        login: 'Login',
        get_started: 'Get Started',
        dashboard: 'Dashboard',
        continue_onboarding: 'Continue Onboarding',

        security: 'Security',

        reviews: 'Reviews',
        about: 'About Us',
        careers: 'Careers',
        press: 'Press',
        contact: 'Contact',
        help_center: 'Help Center'
    },
    greeting: 'Welcome',
    search: {
        placeholder: 'Search sites...',
    },
    notifications: {
        title: 'Notifications',
        none: 'No new notifications',
        time_just_now: 'Just now',
        time_minutes: 'min ago',
        time_hours: 'h ago',
        time_days: 'd ago',
        removed: 'Removed from',
        processing: 'Processing removal:',
        action: 'Action required:',
        submitted: 'New request:',
        update: 'Update:'
    },
    dropdown: {
        signed_in: 'Signed in as',
        details: 'My Details',
        settings: 'Settings',
        plans: 'Plans & Pricing',
        logout: 'Logout',
        support: 'Support',
        appearance: 'Appearance',
        light: 'Light',
        dark: 'Dark',
        language: 'Language',
        active: 'Active'
    },
    titles: {
        dashboard: 'Dashboard',
        protection_score: 'Protection Score',
        scanning: 'Scanning...',
        protection_active: 'Protection Active',
        overview_welcome: "Here's your latest overview",
        link_removal_desc: 'Request removal of links from the web and search engines',
        ai_visibility_desc: 'Monitor and restrict your visibility in AI services',
        dark_web_desc: 'Check if your data has been leaked in data breaches'
    },
    cards: {
        analysis_title: 'Analyzing visibility',
        analysis_text: 'We are analyzing your visibility on databases and search engines. You will be notified when done.',
        cases_title: 'Ongoing Cases',
        cases_desc: 'Status of your removals',
        site_status_title: 'Status on Information Sites',
        site_status_desc: 'Your visibility on major databases',
        status_visible: 'Visible',
        status_protected: 'Protected',
        new: 'New',
        no_cases: 'No cases yet.',
        view_all: 'View all',
        address_tab: 'Address',
        alarm_tab: 'Alert',
        your_address: 'Your Address',
        active: 'Active',
        coming_soon: 'Coming Soon',
        dev_text: 'This feature is under development.',
        link_removal: 'Link Removal'
    },
    premium_modal: {
        title: 'Unlock Premium',
        desc: 'To automatically clear and hide your data from databases and search engines, an active Premium subscription is required.',
        feature1: 'Removal from 7+ sites',
        feature2: 'Google de-indexing',
        feature3: 'Continuous 24/7 monitoring',
        feature4: 'Automatic re-removal',
        button: 'Upgrade to Premium',
        error: 'Could not start payment. Please try again.',
        pro_success_title: 'You have Noctra Pro',
        pro_success_desc: 'Your data is now automatically removed and we monitor your privacy 24/7.',
        manage_subscription: 'Manage subscription',
        portal_error: 'Could not open customer portal. Try again.'
    },
    removal_upgrade: {
        title: 'Protect your identity for real',
        desc: 'Upgrade to Premium to clear your data from Google and 30+ other sites. We handle the entire process for you — automatically.',
        feature1: 'Removal from 7+ data sites',
        feature2: 'Google de-indexing of your data',
        feature3: 'Continuous monitoring and re-removal',
        feature4: 'Personal support and removal report',
        button: 'See plans & upgrade',
        guarantee: '14-day right of withdrawal · Cancel anytime'
    },
    modal: { title: 'Start new removal', desc: 'Select which database you want to remove your data from.', select_site: 'Select Site', start_btn: 'Start Removal', starting_btn: 'Starting...' },
    guides: {
        remove: 'Remove', show: 'Show', hide: 'Hide', step_prefix: 'Step',
        click_remove: "Click on 'Remove'",
        enter_name: "Enter your name in the search box",
        bankid: "Identify with Mobile BankID",
        hide_details: "Hide your details",
        hide_address_phone: "Hide your address and phone number",
        click_hide: "Click to hide your details",
        remove_details: "Remove your details"
    },
    support: {
        title: 'Support',
        faq: 'FAQ',
        new_message: 'New message',
        inbox: 'Inbox',
        no_history: 'You have no message history',
        start_chat: 'Write to start the conversation',
        type_here: 'Write here...'
    },
    common: {
        view_all: 'View all',
        protected: 'Protected',
        warning: 'Warning',
        critical: 'Critical',
        loading: 'Loading...',
        recently: 'Recently',
        more_features: 'More features',
        more: 'More',
        protect: 'Protect',
        beta: 'Beta'
    },
    status: {
        privacy_level: 'Privacy Level',
        fully_protected: 'Fully Protected',
        partially_protected: 'Partially Protected',
        vulnerable: 'Vulnerable',
        removed: 'Removed',
        processing: 'Processing',
        action: 'Action Required',
        submitted: 'Submitted'
    },
    landing: {
        seo: {
            title: "Noctra - Remove your personal data from the web",
            description: "Protect yourself against identity theft and stalking. Noctra deletes your data from Ratsit, MrKoll, Hitta.se and many more."
        },
        hero: {
            remove: "Remove",
            from_web: "From the web with",
            subtitle: "Protect your privacy. We delete your data from sites like Ratsit, MrKoll and Hitta.se – automatically.",
            subtitle_long: "Your personal data is open on the web. We find them. We delete them. And we protect you.",
            cta_start: "Search and delete me",
            cta_how: "How it works",
            cta_protected: "Get protected now",
            no_binding: "No binding period. Start immediately.",
            trust: "Connected to Google Ads and Stripe for your safety"
        },
        benefits: {
            title: "Why choose Noctra?",
            subtitle: "We offer more than just data removal. We give you the freedom to live your life without worrying about your digital safety."
        },
        social_proof: {
            secure_payment: "Pay safely and securely with",
            guarantees: {
                refund: "14-day right of withdrawal",
                cancel: "Cancel anytime",
                no_fees: "No hidden fees"
            }
        },
        family: {
            title: "Invisible online, safe in reality",
            subtitle: "Protection for the whole family, prevent others from finding out your private details",
            description: "Names, addresses, phone numbers, family details and other private data are continuously sold by data brokers. We stop it.",
            protect_list_title: "What we protect:",
            button: "Protect your family now",
            tags: {
                name: "Name",
                age: "Age",
                address: "Address",
                home_value: "Property Value",
                phone: "Phone Number",
                mail: "Email",
                marital_status: "Marital Status",
                relatives: "Relatives",
                images: "Images",
                prev_addresses: "Previous Addresses"
            }
        },
        footer: {
            service_title: "Service",
            company_title: "Company",
            help_title: "Help & Resources",
            privacy_policy: "Privacy Policy",
            terms: "Terms of Service",
            cookie_policy: "Cookie Policy",
            all_rights_reserved: "All rights reserved.",
            part_of: "Noctra is part of Lumidiom AB.",
            secure_payment: "Secure Payment"
        },
        words: {
            address: "your address",
            phone: "your number",
            person: "yourself",
            personal_data: "personal data"
        },
        benefits_cards: {
            control_title: "Take back control",
            control_desc: "You decide who should know where you live. We give you power over your data by deleting it from public records.",
            control_badge: "100% Control",
            support_title: "Personal help",
            support_desc: "No robots, just real people. Our support team is here to help you with everything regarding your security.",
            support_badge: "Premium Support"
        },
        risks: {
            title: "Your data is open to everyone",
            subtitle: "In many regions, personal data are public records. Without active protection, anyone can find your address, income, and family situation in seconds.",
            card1: {
                title: "ID Theft & Fraud",
                desc: "Fraudsters use your public data to take loans, order goods, or open subscriptions in your name."
            },
            card2: {
                title: "Stalking & Threats",
                desc: "Your home should be your castle. Public addresses make it easy for unauthorized persons to seek you and your family out."
            },
            card3: {
                title: "Spam & Telemarketers",
                desc: "Your data is sold to companies that bomb you with advertising. We choke the flow at the source."
            }
        },
        pricing_section: {
            title: "Start protecting yourself today",
            subtitle: "Choose the plan that suits you best",
            yearly: "Yearly",
            monthly: "Monthly",
            save_text: "Save up to 16%",
            pro_exclusive: "Included in Pro",
            guarantee: "14-day right of withdrawal · Cancel anytime",
            bas_title: "Basic",
            pro_title: "Pro",
            onetime_title: "Just need a one-time fix?",
            onetime_desc: "We remove your data from all sites and send a report with proof. No subscription required.",
            onetime_btn: "One-time cleanup — 99 kr",
            cta: "Get protected now",
            best_value: "Best value",
            save_badge: "You save",
            per_person: "Only {price} kr/person",
            month_unit: "mo",
            year_unit: "yr",
            add_family: "Add family members (+29 kr/month)",
            payment_error: "Could not start payment. Please try again.",
            no_commitment: "No commitment",
            features: {
                google_removal: "Google De-indexing (5 links)",
                google_removal_pro: "Google De-indexing (10 links)",
                personal_support: "Personal Support",
                priority_support: "Priority Support",
                no_commitment: "No Commitment",
                darkweb_monitoring: "Dark Web Monitoring",
                ai_visibility: "AI Visibility (ChatGPT, Gemini etc.)",
                one_person: "1 Person",
                two_persons: "2 Persons included",
                removal_7_sites: "Removal from 7+ data sites",
                removal_report: "Removal report with proof",
                monitoring_24_7: "Continuous monitoring 24/7",
                auto_removal: "Automatic re-removal",
                address_alarm: "Address alarm",
                dashboard: "Noctra Dashboard",
                all_basic_included: "Everything in Basic included",
                protection_1_person: "Continuous protection — 1 person",
                protection_2_persons: "Maximum protection — 2 persons incl."
            }
        },
        newsletter: {
            title: "Stay One Step Ahead – Every Week",
            subtitle: "As a Pro customer, you receive an exclusive security newsletter every week with in-depth guides, current threats, and practical tips to protect your identity.",
            button: "Upgrade to Pro",
            features: [
                { text: 'Password Strategies & 2FA', icon: 'KeyRound', color: 'text-blue-400' },
                { text: 'VPN – when do you need it?', icon: 'Wifi', color: 'text-purple-400' },
                { text: 'Backup & 3-2-1 rule', icon: 'HardDrive', color: 'text-emerald-400' },
                { text: 'GDPR – your rights', icon: 'Shield', color: 'text-cyan-400' },
                { text: 'Current fraud threats', icon: 'AlertTriangle', color: 'text-amber-400' },
                { text: 'New threats & trends', icon: 'Eye', color: 'text-rose-400' }
            ]
        },
        knowledge_bank: {
            title: "Knowledge Base & Guides",
            subtitle: "Learn how to protect your digital privacy with our practical guides and articles",
            read_more: "Read more",
            read_time_suffix: "read",
            guides: [
                {
                    title: "5-minute security checklist",
                    description: "Quick actions you can do today to significantly improve your digital security.",
                    category: "Quick Tips"
                },
                {
                    title: "Dark Web: How your data gets there",
                    description: "Understand how stolen personal data is spread on the dark web and what you can do to protect yourself.",
                    category: "Security"
                },
                {
                    title: "Phishing: How to protect yourself",
                    description: "Learn to recognize phishing, smishing and vishing attacks before they trick you of your information.",
                    category: "Security"
                }
            ]
        },
        cta_section: {
            title: "Stop Worrying About Your Personal Data",
            subtitle: "Take control of your digital privacy today. It only takes 2 minutes to get started with Noctra.",
            button: "Get Started Now"
        },
        footer_info: {
            description: "Noctra helps you take control of your digital privacy by automatically removing your personal data from the web.",
            powered_by: "Powered by",
            org_nr: "Reg.no"
        },
        faq: {
            categories: {
                all: "All questions",
                getting_started: "Getting started",
                subscription: "Subscription",
                privacy: "Privacy",
                account: "Account settings",
                notifications: "Notifications",
                security: "Security",
                support: "Support"
            },
            items: [
                {
                    question: "What does Noctra do?",
                    answer: "Noctra helps you remove your personal information from background check sites like Ratsit, Hitta.se, MrKoll, Eniro, and many more. We handle the process for you and continuously monitor so your information doesn't reappear."
                },
                {
                    question: "How long does it take before my information is removed?",
                    answer: "Most sites remove your information within 1-4 weeks. Some sites may take longer depending on their internal processes. You can follow the status in your dashboard."
                },
                {
                    question: "Which sites do you cover?",
                    answer: "We cover all major Swedish background check sites: Ratsit, Hitta.se, MrKoll, Eniro, Merinfo, Birthday.se, and many more. The list is continuously updated."
                },
                {
                    question: "Is it legal to remove one's information?",
                    answer: "Yes, absolutely! According to GDPR, you have the right to request deletion of your personal data. Noctra helps you exercise this right."
                },
                {
                    question: "How much does Noctra cost?",
                    answer: "We offer different packages starting from 29 SEK/month with annual billing. You can see all our prices on the home page. We also offer a free search so you can see where your information is located."
                },
                {
                    question: "Can I cancel my subscription?",
                    answer: "Yes, you can cancel your subscription at any time with no binding period. Your protection continues until the end of your billing period."
                },
                {
                    question: "How do I know it works?",
                    answer: "You get automatic updates via email and can follow all activity in your dashboard in real-time. We show exactly which sites we've contacted and which have confirmed removal."
                },
                {
                    question: "How do you handle my personal identity number?",
                    answer: "We process your personal identity number securely and encrypted only to be able to identify you in databases and request removal. We never share it with unauthorized parties."
                },
                {
                    question: "How do I change my account details?",
                    answer: "You can easily change your account details by logging into your dashboard and going to Settings. There you can update email, password, and other profile settings."
                },
                {
                    question: "What payment methods do you accept?",
                    answer: "We accept all major payment methods: Visa, Mastercard, Klarna, PayPal, Apple Pay, and Google Pay. All payments are processed securely via Stripe."
                },
                {
                    question: "How do I contact support?",
                    answer: "You can contact our support via email or through the chat function in your dashboard. We usually respond within 24 hours on weekdays."
                },
                {
                    question: "How often do you search for my information?",
                    answer: "We perform continuous searches to ensure your information doesn't reappear. Premium customers get ongoing monitoring with direct notifications."
                }
            ],
            guides_title: "Feel free to see our guides",
            guides_subtitle: "Learn more about how you can protect your privacy online.",
            guides: [
                {
                    title: "Registration Guide",
                    description: "Simple guide to get started with your account after purchase."
                },
                {
                    title: "Usage Guide",
                    description: "Everything you need to know about how to use Noctra."
                },
                {
                    title: "How it works",
                    description: "Find out how our service works and which sites we handle."
                },
                {
                    title: "Partnerships",
                    description: "Get in touch with us for a safer and more responsible partnership."
                }
            ],
            hero: {
                title: "Frequently Asked Questions",
                subtitle: "Here you will find answers to the most common questions about how our services work and what you can expect from our service. If you don't find the answer you're looking for, you're always welcome to contact us!",
                filter_title: "What do you want to know more about?"
            },
            contact_cta: {
                title: "Can't find the answer to your question?",
                subtitle: "Our support team is here to help you. Contact us and we will respond as soon as we can.",
                button: "Contact us",
                home_button: "Go to home page"
            }
        }
    },
    auth: {
        login: {
                title: "Welcome back",
                subtitle: "Log in to your account",
                google: "Log in with Google",
                apple: "Log log in with Apple",
                email_btn: "Log in with Email",
                or: "or",
                no_account: "Don't have an account?",
                signup_link: "Get started",
                email_label: "Email",
                password_label: "Password",
                forgot_password: "Forgot password?",
                back: "Back to login options",
                submit: "Log in",
                loading: "Logging in...",
                errors: {
                    generic: "An error occurred",
                    no_email: "Enter your email address first",
                    check_email: "Check your email for reset link!"
                }
            },
            signup: {
                title: "Create account",
                subtitle: "Get started and protect your privacy",
                google: "Continue with Google",
                apple: "Continue with Apple",
                email_btn: "Continue with Email",
                has_account: "Already have an account?",
                login_link: "Log in",
                back: "Back to registration options",
                submit: "Create account",
                loading: "Creating account...",
                success: "Check your email to confirm your account!",
                errors: {
                    invalid_email: "Enter a valid email address",
                    password_length: "Password must be at least 6 characters.",
                    signups_disabled: "Registering new accounts is not possible right now.",
                    generic: "Could not create account. Please try again."
                }
            },
            footer: {
                agree: "By continuing, you agree to our",
                terms: "terms of service",
                and: "and that you receive periodic emails with updates and that you have read our",
                privacy: "privacy policy"
            },
            visual: {
                title: "Your privacy, your terms",
                description: "We erase your tracks from the web so you can live without anyone unauthorized having access to your information.",
                alt: "Noctra app on a smartphone"
            }
        },
        onboarding: {
            title: "Welcome to Noctra! 👋",
            subtitle: "To protect you and remove your data, we need to know who you are. Your data is encrypted and used only for removals.",
            seo_title: "Get started - Noctra",
            seo_desc: "Create your account and choose a plan to start removing your data from the web.",
            steps: { verify: "Verify", name: "Name", country: "Country", address: "Address", plan: "Plan" },
            step1: {
                title_verify: "Verify account",
                title_signup: "Sign up",
                subtitle_verify: "Confirm your email address to continue your setup.",
                subtitle_signup: "Enter your email address to create your account securely, without a password.",
                email_label: "Email address",
                continue_btn: "Continue",
                no_sell: "We never sell your data",
                verify_email_title: "Verify email",
                verify_email_subtitle1: "We have sent a 6-digit code to ",
                verify_email_link_subtitle1: "We have sent a confirmation link to ",
                verify_email_subtitle2: ". Enter the code below.",

                verifying: "Verifying code...",
                send_new: "Send new code",
                send_new_in: "Send new code in",
                change_email: "Change email address?",
                err_invalid_email: "Enter a valid email address",
                err_no_signup: "Signing up new accounts is currently disabled.",
                err_send: "Could not send code. Please try again.",
                err_invalid_code: "Invalid or expired code. Please try again.",
                check_inbox: "Click the link in the email to verify your account.",
                waiting_confirm: "Waiting for verification..."

            },
            step2: {
                title: "Your name",
                subtitle: "Enter your full name",
                err_full_name: "Please enter both first and last name",
                err_save: "Could not save name. Error: ",
                placeholder: "Full name"
            },
            step3: {
                title: "Which country do you live in?",
                subtitle: "We customize our searches based on your region.",
                sweden: "Sweden",
                norway: "Norway",
                denmark: "Denmark",
                finland: "Finland",
                err_save: "Could not save country. Error: "
            },
            step4: {
                title: "Where do you live?",
                subtitle: "This information is used to scan databases and public records for your data.",
                street: "Street Address",
                zip: "Zip Code",
                city: "City",
                street_ph: "Enter street address",
                zip_ph: "Enter zip code",
                city_ph: "Enter city",
                err_save: "Could not save address. Error: "
            },
            step5: {
                title: "Choose your plan",
                subtitle: "You can always upgrade or change plan later",
                yearly: "Yearly",
                save: "Save 16%",
                monthly: "Monthly",
                no_binding: "No commitment",
                err_payment: "Failed to start payment. Try again.",
                onetime_title: "Just need a one-time fix?",
                onetime_desc: "We remove your data and send a report. No subscription.",
                onetime_btn: "One-time cleanup — 99 kr",
                guarantee: "All plans include 14-days refund right. Cancel anytime.",
                free: {
                    period: "Always free",
                    description: "Get started and explore your digital visibility",
                    features: ["Noctra Dashboard", "See your privacy level", "Step-by-step guides", "Chat support"],
                    cta: "Start for free"
                },
                bas: {
                    period: "kr/mo",
                    description: "Continuous protection — we handle the removal for you",
                    features: ["Everything in Free", "Removal from 6+ sites", "Link removal & Google de-indexing", "24/7 Address alert", "Case management with status"],
                    cta: "Select Bas"
                },
                pro: {
                    period: "kr/mo",
                    description: "Maximum protection with Dark Web & AI scanning",
                    badge: "Most popular",
                    features: ["Everything in Bas", "Dark Web scanning", "AI Visibility (ChatGPT, Gemini etc.)", "GDPR removal from AI services", "Weekly security report"],
                    cta: "Select Pro"
                }
            }
        },
        demos: {
            title: "See how Noctra works in practice",
            tabs: {
                monitoring: { title: "24/7 Monitoring", desc: "Scans the web for new threats" },
                removal: { title: "Erase traces", desc: "Hides you from search results" },
                alerts: { title: "Safety alerts", desc: "Get notified if we find something" },
                google: { title: "De-indexing", desc: "Quickly removed from Google" }
            },
            control: {
                protected: "Protected",
                public: "Public",
                hidden: "Hidden from public",
                visible_hitta: "Visible on Hitta.se",
                visible_eniro: "Visible on Eniro",
                profile: "Your Profile",
                home_address: "Home Address",
                phone: "Phone Number"
            },
            scan: {
                recognize: "Analysis recognizing:",
                ratsit: "Ratsit profile",
                mrkoll: "MrKoll address",
                eniro: "Eniro phone",
                scanning: "Scanning databases...",
                identifying: "Identifying data...",
                search_ratsit: "Searching on Ratsit...",
                search_mrkoll: "Searching on MrKoll...",
                search_eniro: "Searching on Eniro...",
                search_hitta: "Searching on Hitta.se...",
                found: "found",
                protected: "protected"
            },
            google: {
                removed: "Removed from Google",
                reason: "Result de-indexed by privacy request",
                desc: "Information removed and unavailable...",
                removed_result: "Removed result",
                your_profile: "Your Profile",
                all_removed: "All results gone!",
                invisible: "Your profile is now invisible on search engines."
            },
            notification: {
                new_finding: "New FINDING",
                finding_desc: "We found your details on",
                new_change: "New CHANGE",
                change_desc: "Your address was changed outside our system",
                deleted: "Removed from",
                deleted_desc: "Your data is now permanently removed from",
                done: "Done",
                protection_active: "Protection active",
                all_updated: "All cases updated",
                activity: "Activity",
                live: "Live",
                searching: "Searching for your data...",
                sources_found: "12 sources identified",
                sending_ratsit: "Sending request to Ratsit",
                removed_ratsit: "Removed from Ratsit",
                sending_hitta: "Sending to Hitta.se",
                removed_hitta: "Removed from Hitta.se",
                clearing_google: "Clearing Google search",
                removed_google_link: "Google link removed",
                done_status: "Done",
                processing_status: "Processing",
                now: "now",
                all_removed_notif: "✅ All data removed! You are now protected."
            },
            removal: {
                age: "Age: 42 years",
                salary_btn: "Check Lars salary anonymously",
                ssn_label: "SSN / Personal ID:",
                remove: "Remove",
                identifying: "Identifying",
                removed: "Removed"
            },
            mockups: {
                greeting: "Hi Lars 👋",
                privacy_level: "Privacy Level",
                fully_protected: "Fully protected",
                information_sites: "Information Sites",
                removed: "Removed",
                cases_title: "Ongoing Cases",
                just_now: "Just now",
                in_queue: "In queue",
                google_link: "Google link",
                support: {
                    agent_greeting: "Hi! 👋 I'm Robin, your personal advisor. How can I help you?",
                    agent_role: "Robin from Noctra",
                    online: "Online",
                    user_msg: "Do I need to do anything else after you've removed my details?",
                    agent_reply: "No, just relax! 😊 We handle all monitoring and clearing automatically. You'll get a notification if anything new comes up."
                }
            },
            carousel: {
                title_1: "We find your data",
                desc_1: "We scan the web and identify where your personal data is publicly available — even on sites you didn't know existed.",
                title_2: "We remove them",
                desc_2: "We send automatic removal requests to sites like Hitta.se, MrKoll, Ratsit and many more databases.",
                title_3: "Follow in real-time",
                desc_3: "Get notifications straight to your phone for every step, from identification to confirmed removal.",
                title_4: "Become invisible on searches",
                desc_4: "We ensure your details disappear from Google and other search engines so no one can look you up."
            }
        },
        address_monitoring: {
            premium_title: 'Address Alert — Premium',
            premium_desc: 'As a premium user, we monitor your address 24/7 and alert you immediately if someone unauthorized tries to register at your address.',
            view_plans: 'View our plans',
            activate_title: 'Activate Address Alert',
            activate_desc: 'Get an instant notification if someone tries to change your registered address. We monitor the Tax Agency and SPAR 24/7.',
            feature_alert: 'Instant Alert',
            feature_alert_desc: 'SMS & Email on changes',
            feature_monitor: '24/7 Monitoring',
            feature_monitor_desc: 'Real-time registry checks',
            feature_block: 'Blocking Service',
            feature_block_desc: 'Help to stop the hijacking',
            activate_btn: 'Activate Protection Now',
            activating: 'Activating...',
            loading: 'Loading...',
            alert_header: '🚨 INTRUDER DETECTED!',
            alert_desc: 'Unknown person has registered at your address. Check your email for details.',
            status_title: 'Address Alert Status',
            status_active: 'Monitoring active',
            status_monitored: 'Your address is monitored in real-time',
            check_btn: 'Check Now',
            checking: 'Checking...',
            address_label: 'Your Registered Address',
            monitored_since: 'Monitored since',
            settings_title: 'Advanced Settings',
            settings_desc: 'Configure intruder protection for apartments and family',
            apt_label: 'Apartment Number (optional)',
            apt_placeholder: 'e.g. 1101',
            apt_desc: 'If you live in an apartment, enter your apartment number to detect unauthorized registrations',
            whitelist_label: 'Approved Residents/Family (optional)',
            whitelist_placeholder: 'e.g. Maria Svensson, Erik Andersson',
            whitelist_desc: 'Enter names separated by commas. The system will not alert if these people live at your address.',
            save_btn: 'Save Settings',
            saving: 'Saving...',
            toast_success: 'Address alert activated!',
            toast_error: 'Could not activate monitoring.',
            toast_generic_error: 'An error occurred.',
            toast_fill_address: 'Please fill in your address under "My Details" first.',
            toast_check_failed: 'Check failed.',
            toast_check_error: 'Could not run check.',
            toast_settings_saved: 'Settings saved!',
            toast_settings_error: 'Could not save settings.',
            protection_status_safe: 'Your address is protected',
            protection_status_alert: 'WARNING: Change detected!',
            last_checked: 'Last checked',
            active_badge: 'ACTIVE',
            alarm_badge: 'ALARM',
            monitored_address_label: 'Monitored Address',
            report_agency: 'Report to the Tax Agency →'
        },
        ai_visibility: {
            title: 'AI Visibility',
            subtitle: 'We manually check if your personal data appears in responses from popular AI services.',
            requestScan: 'Request scan',
            requesting: 'Requesting...',
            alreadyRequested: 'Scan in progress',
            scanPending: 'We have received your request. Our team is now manually reviewing each AI service — you will be notified when the results are ready.',
            scanCompleted: 'Scan completed',
            servicesChecked: 'services checked',
            exposures: 'exposures found',
            removals: 'removals',
            noDataFound: 'No data found',
            dataFound: 'Data found',
            remove: 'Remove',
            ignore: 'Ignore',
            details: 'Details',
            requestedAt: 'Requested',
            completedAt: 'Completed',
            infoText: 'Noctra manually checks your exposures in ChatGPT, Google Gemini, Claude, Microsoft Copilot, and Perplexity. If we find your personal data, you can choose to request removal — we handle the entire GDPR process for you.',
            noScanYet: 'You have not requested an AI scan yet. Click below to let us review your exposures.',
            removed: 'Removed',
            removalRequested: 'Requested',
            premiumTitle: 'AI Visibility — Premium',
            premiumDesc: 'As a premium user, we find and remove your personal data from ChatGPT, Gemini, and other major AI models.',
            viewPlans: 'Explore plans',
            errorRequest: 'Could not send request. Please try again.',
            refresh: 'Refresh',
            scanning: 'Scanning',
            found: 'Found',
            not_found: 'Not found',
            in_progress: 'In progress',
            ignored: 'Ignored'
        },
        dark_web: {
            title: 'Dark Web Scanning',
            subtitle: 'We check if your personal data has been leaked in known data breaches.',
            scan: 'Start scan',
            scanning: 'Scanning...',
            rescan: 'Scan again',
            lastScan: 'Last scan',
            breachesFound: 'breaches found',
            noBreaches: 'No breaches found',
            exposedData: 'Exposed data',
            severity: 'Severity',
            high: 'High',
            critical: 'Critical',
            medium: 'Medium',
            recommendation: 'Recommendation',
            changePassword: 'Change password immediately',
            monitorAccount: 'Monitor this account',
            enable2fa: 'Enable two-factor authentication',
            totalExposures: 'Total exposures',
            passwordLeaks: 'Password leaks',
            scannedEmail: 'Scanned email',
            source: 'Source',
            indicative: 'Indicative (unconfirmed match)',
            affectedAccounts: 'affected accounts',
            history: 'Scan history',
            infoText: 'Results are based on data from Have I Been Pwned (HIBP) — the world\'s largest database for data breaches.',
            leaks: 'leaks',
            passwords: 'passwords',
            security_priority: 'Security is our priority',
            all_data_checked: 'All data is checked against authentic sources from the dark web and known breaches.',
            premiumTitle: 'Dark Web Scanning — Premium',
            premiumDesc: 'As a premium user, we monitor your details 24/7 and alert you immediately if we find your information in new leaks.',
            viewPlans: 'View our plans',
            searchTitle: 'Search for your email',
            accounts: 'accounts',
            scanFailed: 'Scan failed'
        },
        link_removal: {
            title: 'Request Link Removal',
            subtitle: 'Paste a link you want removed from the web or search engines',
            url_label: 'URL to remove',
            url_placeholder: 'https://example.com/page-with-your-data',
            type_label: 'Removal type',
            type_search: 'Search Engine',
            type_search_desc: 'Remove from Google, Bing etc.',
            type_website: 'Website',
            type_website_desc: 'Remove from a specific website',
            desc_label: 'Description (optional)',
            desc_placeholder: 'Describe why you want this link removed, e.g. what information is shown...',
            submit: 'Submit request',
            submitting: 'Submitting...',
            success: 'Your request has been submitted!',
            success_desc: 'We are processing your request and will notify you when done.',
            history_title: 'Your requests',
            history_empty: 'No active requests',
            history_empty_desc: 'Your link removal requests will appear here.',
            status_submitted: 'Submitted',
            status_processing: 'Processing',
            status_removed: 'Removed',
            status_action: 'Action Required',
            invalid_url: 'Enter a valid URL (start with http:// or https://)',
            new_request: 'New request',
            processing_time: 'We process your request within 1-3 business days',
            future_cases: 'Your future cases will appear here.',
            premiumTitle: 'Premium Feature',
            premiumDesc: 'As a premium user, you can request automatic removal of personal data from Google and other websites.',
            viewPlans: 'View our plans'
        },
        my_details: {
            title: 'Personal Information',
            verified: '✓ Verified',
            full_name: 'Full Name',
            ssn: 'Social Security Number',
            ssn_desc: 'Cannot be changed manually.',
            ssn_title: 'Contact support to change SSN',
            email: 'Email Address',
            phone: 'Phone Number',
            address: 'Address',
            zip_code: 'Zip Code',
            city: 'City',
            save: 'Save Changes',
            saving: 'Saving...',
            success: 'Details saved!',
            error: 'Could not save: ',
        },
        settings: {
            title: 'Settings',
            subscription: 'Subscription',
            next_billing: 'Next billing',
            active: 'Active',
            manage_billing: 'Manage payments at Stripe',
            notifications: 'Notifications',
            email_notif: 'Email on new cases',
            email_notif_desc: 'Get an email when we find new info about you.',
            weekly_report: 'Weekly report',
            weekly_report_desc: 'Summary of your safety status.',
            security: 'Security & Account',
            password: 'Password',
            password_desc: 'Reset your password via email.',
            change_password: 'Change password',
            sending: 'Sending...',
            delete_account: 'Delete account',
            delete_confirm: 'Are you sure you want to delete your account? This cannot be undone.',
            delete_support: 'Contact support@noctra.se to close your account.',
            portal_opening: 'Opening Stripe Customer Portal...',
            portal_error: 'Could not open customer portal. Contact support.',
            password_error: 'Could not send reset link: ',
            password_sent: 'A reset link has been sent to your email!',
            unexpected_error: 'An unexpected error occurred.',
            cancels_on: 'Cancels on',
            cancelling: 'Cancelling...',
            email_enabled: 'Email notifications enabled',
            email_disabled: 'Email notifications disabled',
            weekly_enabled: 'Weekly report enabled',
            weekly_disabled: 'Weekly report disabled',
        },
        plans_page: {
            title: 'Choose your plan',
            subtitle: 'Upgrade to get full protection and continuous monitoring.',
            premium_active_title: 'You have an active plan!',
            premium_active_desc: 'Thank you for using our service. Your features are unlocked and active on your account. You do not need to choose a new plan.',
            premium_active_badge: 'ACTIVE',
            yearly: 'Yearly',
            save: 'Save 16%',
            monthly: 'Monthly',
            onetime_title: 'Just need a one-time fix?',
            onetime_desc: 'Full cleanup with a report. No subscription required.',
            onetime_btn: 'One-time Cleanup — 99 kr',
            most_popular: 'Most Popular',
            month_suffix: '/mo',
            year_suffix: 'kr / yr',
            current_plan: 'Your current plan',
            choose_plan: 'Choose plan',
            payment_error: 'Could not start payment. Please try again.',
            trust: {
                payment: 'Secure Payment',
                id: 'ID-Protection',
                support: 'Premium Support',
                commitment: 'No commitment'
            },
            bas: {
                users: "Continuous protection — 1 person",
                features: [
                    "1 Person",
                    "Removal from 7+ databases",
                    "Google de-indexing (5 links)",
                    "Removal report with proof",
                    "24/7 continuous monitoring",
                    "Automatic re-removal",
                    "Address Alert",
                    "Noctra Dashboard"
                ]
            },
            pro: {
                users: "Maximum protection — 2 people incl.",
                features: [
                    "2 People included",
                    "Everything in Basic included",
                    "Dark Web Monitoring",
                    "AI Visibility (ChatGPT, Gemini, etc.)",
                    "Google de-indexing (10 links)",
                    "Add family members (+29 kr/mo)",
                    "Priority Support"
                ]
            }
        },
        support_page: {
            title: 'Help & Support',
            subtitle: 'We are here to help you with your privacy.',
            contact_us: 'Contact us',
            thanks: 'Thanks for your message!',
            thanks_desc: 'We will get back to you via email as soon as possible, usually within 24 hours.',
            send_new: 'Send a new message',
            subject: 'Subject',
            select_subject: 'Select subject...',
            subject_case: 'Question about case',
            subject_billing: 'Billing & Payment',
            subject_tech: 'Technical problem',
            subject_other: 'Other',
            message: 'Message',
            placeholder: 'Describe your case here...',
            send_btn: 'Send message',
            sending: 'Sending...',
            live_chat: 'Direct Messaging',
            chat_desc: 'Write directly to our team. We usually respond within 1 hour.',
            online: 'We are online now',
            faq: 'Frequently Asked Questions',
            see_all: 'See all questions',
            error_send: 'Could not send the message. Please try again.',
            error_unexpected: 'An unexpected error occurred.',
            faq_q1: "How long does a removal take?",
            faq_a1: "Most removals happen within 1-2 weeks. Some sites like MrKoll can take up to 30 days as they require manual processing.",
            faq_q2: "Will my data come back?",
            faq_a2: "We monitor the sites continuously. If your data reappears, you will receive an alarm and we will start a new removal automatically.",
            faq_q3: "What is included in my subscription?",
            faq_a3: "You get unlimited removals from all connected databases, real-time identity monitoring, and priority support."
        },
        
        how_it_works: {
            hero: {
                title: 'How it works',
                subtitle: 'Protect your online privacy in four easy steps. We handle everything for you.'
            },
            steps: {
                step1: {
                    title: 'Choose plan',
                    description: 'Compare and choose the plan that best fits you based on how many people need protection. All our packages include unlimited link removal and removal from information sites.',
                    cta: 'See our plans'
                },
                step2: {
                    title: 'Activate your account',
                    description: 'After choosing your desired plan and completing your purchase, you will receive an activation email.',
                    phone: {
                        title: 'Activate your account',
                        greeting: 'Hi Axel',
                        desc: 'Your account has been created and you can now log in to activate your account.'
                    }
                },
                step3: {
                    title: 'Removal',
                    description: 'In your account you can instantly remove yourself from various information sites. We remove you from MrKoll and remove your links from Google. You can follow the entire process directly in the app.',
                    phone_status: 'Removal status',
                    phone_found: 'Found',
                    phone_removed: 'Removed'
                },
                step4: {
                    title: 'Monitoring',
                    description: 'Our monitoring keeps track if new links about you appear. You will then receive a notification in the app and can immediately choose if you want us to remove the link.',
                    phone_active: 'Monitoring active',
                    phone_last: 'Last: Just now',
                    phone_protected: 'Protected',
                    phone_scanning: 'Scanning sources',
                    phone_scanning_status: 'Scanning...',
                    phone_results: 'No new hits found'
                }
            },
            pricing: {
                title: 'Hide your details and get protected now',
                subtitle: 'Choose the plan that suits you best',
                yearly: 'Yearly plan',
                save: 'Save up to 16%',
                monthly: 'Monthly',
                guarantee: '14 days return policy · Cancel anytime',
                swipe: '← Swipe to see both plans →',
                onetime_title: 'Just need a one-time fix?',
                onetime_desc: 'We remove your details from all sites and send a report with proof.',
                onetime_btn: 'One-time cleanup — 99 kr',
                best_value: 'Best value',
                mo: 'mo',
                yr: 'yr',
                no_binding: 'No commitment',
                you_save: 'You save',
                only: 'Only',
                per_person: 'kr/person',
                get_protected: 'Get protected now',
                loading: 'Loading...'
            },
            trust: {
                payment: 'Pay safely and securely with',
                guarantee: '14 days return policy',
                cancel: 'Cancel anytime',
                no_fees: 'No hidden fees'
            },
            newsletter: {
                badge: 'Included in Pro',
                title: 'Stay one step ahead – every week',
                desc: 'As a Pro-customer, you will receive an exclusive weekly security newsletter with in-depth guides, current threats and practical tips to protect your identity.',
                cta: 'Upgrade to Pro',
                topics: [
                    'GDPR – your rights',
                    'Current fraud threats',
                    'New threats & trends',
                    'Weekly security report'
                ]
            },
            footer: {
                rights: 'All rights reserved.'
            }
        },
        cases_page: {
            site: 'Database / Site',
            status: 'Status',
            updated: 'Last updated',
            details: 'Details',
            no_cases: 'No cases yet',
            no_cases_desc: 'Your cases will appear here once we start scanning.',
            id: 'Case ID',
            created: 'Created',
            type: 'Type',
            website: 'Website',
            description: 'Description',
            status_removed: 'Removed',
            status_processing: 'Processing',
            status_action: 'Action required',
            status_submitted: 'Submitted',
            status_unknown: 'Unknown status',
            type_new: 'New request',
            type_processing: 'Processing',
            type_completed: 'Completed',
            type_action: 'Action required',
            type_other: 'Other',
            id_label: 'ID'
    },
    poa: {
        nav_label: 'Power of Attorney',
        title: 'Power of Attorney',
        subtitle: 'To act on your behalf, you need to sign a digital power of attorney.',
        legal_body_1: 'I hereby authorize Lumidiom AB (reg.no 559438-1647) to represent me in all matters concerning deletion, restriction, and handling of my personal data.',
        legal_body_2: 'This power of attorney covers contact with search engines (such as Google, Bing) and providers of search services (such as MrKoll, Ratsit, Hitta.se, Eniro, Lexbase, Krimfup, etc.). The agent has the right to request deletion on my behalf under GDPR Article 17 and to object under GDPR Article 21.',
        verification_title: 'Verification',
        verification_body: 'This document is digitally signed via Noctra Verification System. Timestamp, IP address, and identity verification are automatically recorded at signing.',
        checkbox_label: 'I have read and accept the power of attorney above and authorize Lumidiom AB to act on my behalf.',
        sign_button: 'Sign digitally',
        signing: 'Signing...',
        signed_title: 'Power of Attorney Signed',
        signed_desc: 'Your power of attorney is active. We can now act on your behalf.',
        signed_at: 'Signed',
        version_label: 'Version',
        status_active: 'Active',
        error: 'Could not sign the power of attorney. Please try again.',
        security_note: 'Your signature is securely recorded with timestamp and IP address.',
        banner_title: 'Sign your Power of Attorney',
        banner_desc: 'We need your Power of Attorney to start removing your data from the web.',
        banner_cta: 'Sign now'
    }
};
